import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

export const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const reserve = document.getElementById("reserver");
      const past = window.scrollY > window.innerHeight * 0.9;
      const inReserve = reserve && reserve.getBoundingClientRect().top < window.innerHeight * 0.5;
      setVisible(past && !inReserve);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-5 left-4 right-4 z-50 md:hidden"
        >
          <button
            data-testid="sticky-mobile-cta"
            onClick={() => scrollToId("reserver")}
            className="w-full bg-[#0D0D0D] text-[#FAF8F5] font-display uppercase tracking-[0.15em] text-sm py-4 rounded-full shadow-2xl shadow-black/30 border border-white/10"
          >
            Pré-réserver — Gratuit
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
